import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { ProtocolListStore, ProtocolListState } from './protocol-list.store';

@Injectable({ providedIn: 'root' })
export class ProtocolListQuery extends QueryEntity<ProtocolListState> {

  constructor(protected store: ProtocolListStore) {
    super(store);
  }

}
